












































































































































































/* eslint-disable @typescript-eslint/camelcase */
import { Vue, Component } from 'vue-property-decorator'

import EditJobDialog from './EditJobDialog.vue'
import CloseJobDialog from './CloseJobDialog.vue'
import EditShiftDialog from './EditShiftDialog.vue'
import QrCodeDialog from './QrCodeDialog.vue'
import EditPaymentDialog from '@/views/payments/EditPaymentDialog.vue'

import GMap from '@/components/GMap.vue'
import ClockEvents from '@/components/ClockEvents.vue'
import ClipboardCopy from '@/components/ClipboardCopy.vue'
import TaskList from '@/components/TaskList.vue'
import ShiftList from '@/components/ShiftList.vue'

import { currentUserIs, UserRole, Managers } from '@/types/Users'
import { Job } from '@/types/Jobs'
import { loadJob, refreshClockInCode } from '@/services/jobs'

@Component({
  components: {
    EditJobDialog,
    CloseJobDialog,
    EditShiftDialog,
    QrCodeDialog,
    EditPaymentDialog,
    GMap,
    ClockEvents,
    ClipboardCopy,
    TaskList,
    ShiftList,
  },
})
export default class JobView extends Vue {
  loading = false
  editJobDialog = false
  closeJobDialog = false
  createShiftDialog = false
  qrCodeDialog = false
  createInvoiceDialog = false
  refreshingClockInCode = false
  shifts = []

  metaInfo() {
    return {
      title: this.job?.name || 'Job',
    }
  }

  async mounted() {
    this.loading = true
    try {
      await loadJob(this.$store, parseInt(this.$route.params.jobId))
    } finally {
      this.loading = false
    }
  }

  get job(): Job {
    return this.$store.getters.job(parseInt(this.$route.params.jobId))
  }

  get userIsManager() {
    return currentUserIs(...Managers)
  }

  get userIsOrgManager() {
    return currentUserIs(UserRole.Admin)
  }

  openQrCodeDialog() {
    this.qrCodeDialog = true
  }

  get userLocation() {
    return this.$store.state.users.userLocation
  }

  get iAmVerified() {
    return this.$store.getters.iAmVerified
  }

  get navigationUrl() {
    const position = this.userLocation && `${this.userLocation.lat},${this.userLocation.lng}`
    const address = `${this.job.address}, ${this.job.city}, ${this.job.state} ${this.job.zip_code}`
    return `https://www.google.com/maps/dir/?api=1${position ? `&origin=${position}` : ''}&destination=${address}`
  }

  async refreshClockInCode() {
    this.refreshingClockInCode = true
    try {
      await refreshClockInCode(this.$store, this.job.id)
    }
    finally {
      this.refreshingClockInCode = false
    }
  }
}
